import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDeviceId } from "../utils/deviceId";
import questions from "../data/questions";
import Result from "./Result";

const QuizPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const deviceId = getDeviceId();

  const [questionData, setQuestionData] = useState(null);
  const [selected, setSelected] = useState(null);
  const [answered, setAnswered] = useState(false);

  useEffect(() => {
    // const [slugId, slugDeviceId] = slug.split("-");
    // if (slugDeviceId !== deviceId) {
    //   navigate("/invalid");
    //   return;
    // }

    const question = questions[slug];
    if (!question) {
      navigate("/not-found");
      return;
    }

    const wasAnswered = localStorage.getItem(`answered-${slug}`);
    setAnswered(!!wasAnswered);
    setQuestionData({ ...question, slug });
  }, [slug, deviceId, navigate]);

  const handleAnswer = (index) => {
    if (answered) return;
    setSelected(index);
    localStorage.setItem(`answered-${slug}`, "true");
    setAnswered(true);

    // Buchstaben speichern, wenn Antwort korrekt ist
    const isCorrect = Array.isArray(questionData.correctAnswer)
        ? questionData.correctAnswer.includes(index)
        : index === questionData.correctAnswer;
    if (isCorrect && questionData.letter) {
        // Hole bisherige Buchstaben
        const letters = JSON.parse(localStorage.getItem("collectedLetters") || "[]");
        // Füge neuen Buchstaben hinzu, falls noch nicht vorhanden
        // if (!letters.includes(questionData.letter)) {
            letters.push(questionData.letter);
            localStorage.setItem("collectedLetters", JSON.stringify(letters));
        // }
    }

    setTimeout(() => navigate("/home"), 4000); // Weiterleitung zurück nach 4s
  };

  if (!questionData) return <p>Lade Frage …</p>;
  if (answered && selected === null) {
    return <p>Du hast diese Frage bereits beantwortet. Weiter zum nächsten QR-Code!</p>;
  }

  return (
    <div className="quiz-page">
      <h2>{questionData.question}</h2>
      <div className="answers">
      {questionData.options.map((opt, idx) => (
        <button
          key={idx}
          onClick={() => handleAnswer(idx)}
          disabled={selected !== null}
        >
          {opt}
        </button>
      ))}
      </div>
      {selected !== null && (
        <Result
          isCorrect={
            Array.isArray(questionData.correctAnswer)
              ? questionData.correctAnswer.includes(selected)
              : selected === questionData.correctAnswer
          }
          correctAnswer={questionData.correctAnswer}
          selectedAnswer={selected}
          options={questionData.options}
          letter={questionData.letter}
        />
      )}
    </div>
  );
};

export default QuizPage;
